import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import { FileService } from '../attachment-dialog/file.service';
import { ActivityService } from 'src/app/core/services/activity.service';
import { Subject } from 'rxjs';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';
import { MultipleFileDialogComponent } from '../multiple-file-dialog/multiple-file-dialog.component';
import { ProfileService } from '../../services/profile.service';
import { FileDownloadService } from '../../services/file-download.service';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
  standalone: false,
})
export class AttachmentComponent implements OnInit, OnChanges, OnDestroy {
  list: string[] = ['abc.jpg', 'def.jpg', 'ghi.jpg'];
  filesList: File[] = [];
  allFilesList = [];
  fileNameArray = [];
  editFileNameArray = [];
  showAttachmentMode: boolean = false;
  bool: boolean;
  multifileUpload: boolean;
  showAttachment: boolean = false;
  fileMerge = [];
  lastindex: number;
  fileArray = [];
  filename = [];
  newArrayfile: any;
  deletedFile = [];
  fileDeleteSub = new Subject();
  checked = false;
  multiSelectFlag: boolean = false;
  key: number;
  showAttachments = false;
  @Input() label: string;
  @Input() ModuleData: object;
  @Input() SendfileInput: object;
  @Input() linkdownload: boolean;
  @Input() allowedTypes: string;
  @Input() enableToggle: boolean;
  @Input() toggleBtn: boolean = false;
  @Input() uploadType: string = 'multiple';
  @Output() fileOutput = new EventEmitter<object>();
  @Output() existingFile = new EventEmitter<object>();
  @Input() editId: object;
  @Input() viemMode: boolean = false;
  @Input() activityModuleFlag: boolean;
  @Input() isMapFile: boolean = false;
  @Input() offerRejectCheck: boolean;
  @Input() offerInvalidRejectCheck: boolean;
  // when set, only attachment types whose attachmentType matches this value are offered in the category dropdown
  @Input() attachmentCategoryFilter: string;
  @Input() hideToggle = false;
  autoMapActivityId;
  cmpHirType = localStorage.getItem('fresherCompHiringTypeId');
  attachmnetTypeData = [];

  data = {
    // Required
    type: 'Attachment Icon', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: '', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '9', //Required.  Unique page id
    itype: '', // type of interaction - SWIPE, SCRUB (fast forward using page thumbnails) or AUTO
    stageto: '', // game level, stage of page id to which the navigation was done
  };
  objA: any;
  fileDetails: any;
  files = [];
  activity: string;

  constructor(
    public dialog: MatDialog,
    private fileService: FileService,
    private activityService: ActivityService,
    private profileService: ProfileService,
    private _telemetryServices: TelemetryServices,
    private fileDownloadService: FileDownloadService
  ) {}

  ngOnInit() {
    // telemtry  API CALL and, send data
    this.activity = this.activityService.getAct();
    if (this.activity == '600301' && this.cmpHirType == '1') {
      this.objA = this.activityService.getObj();
      this.fileService.getFile(this.objA.candidateId, this.objA.applicationId).subscribe((res) => {
        this.fileDetails = res;

        const files = Object.keys(this.fileDetails);
        files.forEach((element) => {
          if (this.fileDetails[element] != null) {
            if (this.fileDetails['offerLetter'] == null) {
              if (element != 'offerLetter') {
                const filename = element[0].toUpperCase() + element.slice(1);
                this.files.push({
                  fileName: filename.replace(/([A-Z])/g, ' $1').trim(),
                  value: this.fileDetails[element],
                });
              }
            } else {
              if (
                !(element == 'salarySlipsFirst' || element == 'salarySlipsSecond' || element == 'salarySlipsThird') &&
                this.fileDetails[element] != null
              ) {
                const filename = element[0].toUpperCase() + element.slice(1);
                let fileName = filename.replace(/([A-Z])/g, ' $1').trim();
                if (element == 'offerLetter') {
                  fileName = 'Offer Letter(Last Organization)';
                }
                this.files.push({ fileName: fileName, value: this.fileDetails[element] });
              }
            }
          }
        });
      });
    }

    this.data.type = '';
    this.data.subtype = 'Attachment Icon';
    this.data.itype = 'AUTO';
    this.data.stageto = 'Initial attachment page';
    if (this.data) {
      this._telemetryServices.telemetryImpression(this.data);
    }

    // this.showAttachmentMode = true;
    if (this.editId) {
      if (this.activityModuleFlag) {
        console.log(this.editId);
        this.fileService
          .getActivityFileData(this.editId['objectId'], this.editId['objectType'], this.editId['activityId'])
          .subscribe((res) => {
            const obj1 = res.ids;
            if (obj1) {
              const mapped = Object.keys(obj1).map((key) => ({ fileName: obj1[key], fileID: key }));
              mapped.forEach((element) => {
                // this.showAttachmentMode = true;
                this.showAttachments = true;
                this.checked = true;
                this.toggleBtn = true;
                this.editFileNameArray.push({ fileName: element.fileName, fileID: element.fileID });
              });
            }
          });
      } else {
        this.fileService.getFileData(this.editId['objectId'], this.editId['objectType']).subscribe((res) => {
          const object = res.ids;
          if (object) {
            const mapped = Object.keys(object).map((key) => ({ fileName: object[key], fileID: key }));
            mapped.forEach((element) => {
              // this.showAttachmentMode = true;
              this.showAttachments = true;
              this.checked = true;
              this.toggleBtn = true;
              this.editFileNameArray.push({ fileName: element.fileName, fileID: element.fileID });
            });
          }
        });
      }
      if (this.editId['activityId'] == 500317) {
        this.profileService.getFileIds(this.editId['objectId'], 'AP', 245).subscribe((hrData) => {
          if (hrData && hrData.id) {
            this.showAttachments = true;
            this.checked = true;
            this.toggleBtn = true;
            this.editFileNameArray.push({ fileName: 'HR Application Form', fileID: hrData.id });
          }
        });
      }
    }
    const existingFileArray = this.editFileNameArray;
    this.existingFile.emit({ existingFileArray });

    if (this.isMapFile) {
      const isUpdateOfferDetails = this.activity === '600103';
      const typeCode = this.cmpHirType === '9' && isUpdateOfferDetails ? 'OO' : 'AP';
      this.fileService
        .getAttachmentType(typeCode)
        .subscribe((attachTypes) => (this.attachmnetTypeData = this.filterAttachmentTypes(attachTypes)));
    }
  }

  private filterAttachmentTypes(attachTypes: any[]): any[] {
    if (!this.attachmentCategoryFilter) return attachTypes;
    return attachTypes.filter((elem) => elem.attachmentType === this.attachmentCategoryFilter);
  }

  openDialog() {
    const dialogRef = this.dialog.open(AttachmentDialogComponent, {
      width: '500px',
      data: {
        attachmentList: this.filesList,
        ModuleData: this.SendfileInput,
        allowedfileType: this.allowedTypes,
        uploadType: this.uploadType,
        editFileNameArray: this.editFileNameArray,
        existingFiles: this.fileNameArray,
        isMapFile: this.isMapFile,
      },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        if (this.isMapFile) {
          const dupArr = await this.automappingFile(result);
          this.manualMapping(dupArr);
        } else {
          const fileArrValues = [];
          //for single file
          if (this.uploadType == 'single') {
            this.allFilesList.splice(0, this.allFilesList.length);
            this.fileNameArray.splice(0, this.fileNameArray.length);
          }
          //For New Files
          result.forEach((fileValue) => {
            if (this.fileNameArray.indexOf(fileValue.name) === -1) {
              this.fileNameArray.push(fileValue.name);
              this.allFilesList.push(fileValue);
            } else {
              this.allFilesList.forEach((fileArr) => {
                if (fileValue.name != fileArr['name']) {
                  fileArrValues.push(fileArr);
                }
              });
              //Override the last same name file
              delete this.allFilesList;
              this.allFilesList = fileArrValues;
              this.allFilesList.push(fileValue);
            }
          });

          if (this.editFileNameArray) {
            //For Edit Files
            const editFileNameArrayTemp = [];
            const deletedFileTemp = [];

            this.editFileNameArray.forEach((fileValue) => {
              // const res = result.filter(function (data) {
              result.filter(function (data) {
                if (data['name'] == fileValue.fileName) {
                  deletedFileTemp.push(fileValue);
                } else {
                  editFileNameArrayTemp.push(fileValue);
                }
              });
            });
            delete this.editFileNameArray;
            this.editFileNameArray = editFileNameArrayTemp;
            if (deletedFileTemp && deletedFileTemp.length > 0) {
              //delete this.deletedFile;
              this.deletedFile = deletedFileTemp;
            }
          }
          this.onFileSelected(this.allFilesList);
        }
      }
    });
  }

  removeParent(closebtn, fileID) {
    const FileValuesDelete = [];
    this.allFilesList.forEach((fileValue) => {
      const fileObj = fileValue.attachmentId ? fileValue.file : fileValue;
      if (fileObj.name != fileID) {
        FileValuesDelete.push(fileValue);
      }
    });
    delete this.allFilesList;
    this.allFilesList = FileValuesDelete;

    const FileValuesDeleteArray = [];
    this.fileNameArray.forEach((fileValue) => {
      if (fileValue != fileID) {
        FileValuesDeleteArray.push(fileValue);
      }
    });
    delete this.fileNameArray;
    this.fileNameArray = FileValuesDeleteArray;

    const fileMerge = this.allFilesList;
    const deletedFile = this.deletedFile;
    this.fileOutput.emit({ fileMerge, deletedFile, fileMerge1: fileMerge, deletedFile1: deletedFile });
  }

  removeEditParent(closebtn, fileID) {
    const FileValuesDelete = [];
    this.editFileNameArray.forEach((fileValue) => {
      if (fileValue.fileID != fileID) {
        FileValuesDelete.push(fileValue);
      } else {
        this.deletedFile.push(fileValue);
      }
      const fileMerge = this.allFilesList;
      const deletedFile = this.deletedFile;
      this.fileOutput.emit({ fileMerge, deletedFile, fileMerge1: fileMerge, deletedFile1: deletedFile });
    });
    delete this.editFileNameArray;
    this.editFileNameArray = FileValuesDelete;
  }

  downloadFile(fileID: any) {
    this.fileService.downloadFile(fileID).subscribe(
      (res) => {
        this.fileDownloadService.downloadFileFromResponse(res);
      }
    );
  }
  downloadFiles(val){
    this.fileDownloadService.downloadFileFromResponse(val);
  }

  //Multi Chunks
  onFileSelected(filesArray) {
    const files = filesArray;
    this.filename = [];
    this.fileMerge = [];
    const lastChunksize = 0;
    const chunkSize = 524288 * 10; //maximum 512 = 524,288, 256 = 262,144 B
    this.lastindex = files.length;
    this.key = 1;

    for (const file1 of files) {
      this.filename.push(file1.name);
      if (this.uploadType == 'single' && this.filename.length > 0) {
        this.fileMerge.splice(0, this.fileMerge.length);
      }
      this.readFile(file1, lastChunksize, this.myCallback.bind(this), chunkSize);
    }
    const _fileMerge1 = this.fileMerge;
    const _deletedFile1 = this.deletedFile;
    // this.fileOutput.emit({ fileMerge, deletedFile })
  }

  // uploadSingleFile(file,lastChunksize,chunkSize){
  //   this.replaceFile(this.filename[0].fileID);
  //     this.fileDeleteSub.subscribe(() =>{
  //       this.filename = [];
  //       //this.attachData = [];
  //       this.readFile(file, lastChunksize, this.myCallback.bind(this),chunkSize);
  //     })
  // }

  //  console.log('fileArray',this.fileArray)
  myCallback(file, lastChunksize1, result, chunkSize) {
    lastChunksize1 = lastChunksize1 + chunkSize;
    if (result) {
      this.readFile(file, lastChunksize1, this.myCallback.bind(this), chunkSize);
    } else {
      // if (this.uploadType == 'single') {
      const fileMerge1 = this.fileMerge;
      const deletedFile1 = this.deletedFile;
      this.fileOutput.emit({ fileMerge1, deletedFile1 });
      // }
      ///end recursion
    }
  }

  readFile(file, lastChunksize1: number, callback, chunkSize) {
    const fileBlob1 = file.slice(lastChunksize1, lastChunksize1 + chunkSize);
    if (fileBlob1.size != 0) {
      const fileReader = new FileReader();
      fileReader.onloadend = (_result) => {
        this.fileMerge.push(file);
        return callback(file, lastChunksize1, fileReader.result, chunkSize);
      };
      fileReader.readAsText(fileBlob1);
    } else {
      return callback(file, lastChunksize1, false);
    }
  }

  // replaceFile(fileID){
  //   let observable =   this.fileService.deleteFile(fileID).subscribe(
  //       (res) => {
  //           let FileValuesDelete = [];
  //           this.filename.forEach(file => {
  //               if(file.fileID != fileID)
  //               {
  //                 FileValuesDelete.push(file);
  //               }
  //           });
  //           delete this.filename;
  //           this.filename = FileValuesDelete;
  //           //this.fileSizeError = '';
  //           this.fileService.setFileUploadEvent(this.filename);
  //           let observ = this.fileDeleteSub.observers[this.fileDeleteSub.observers.length-1];
  //           this.fileDeleteSub.observers.splice(0,this.fileDeleteSub.observers.length);
  //           this.fileDeleteSub.observers.push(observ);
  //           this.fileDeleteSub.next();
  //       },
  //       (err) => {
  //        // this.error = err
  //       }
  //     );
  // }

  ngOnChanges() {
    if (this.editId) {
      this.showAttachmentMode = true;
    }

    this.checked = this.showAttachments = this.enableToggle ? true : false;
    if (this.isMapFile && this.enableToggle) {
      const typeCode = 'AP';
      this.fileService
        .getAttachmentType(typeCode)
        .subscribe((attachTypes) => (this.attachmnetTypeData = this.filterAttachmentTypes(attachTypes)));
    }
  }

  ngOnDestroy() {
    // telemtry end call

    this.data.subtype = 'Attachment Icon cleanup stage/end of page';
    this.data.itype = 'AUTO';
    this.data.stageto = 'destroy component,initial page';
    if (this.data) {
      this._telemetryServices.telemetryEnd(this.data);
    }
  }

  automappingFile(fileArray) {
    const dupFileObjArray = [];
    if (fileArray && fileArray.length) {
      const isUpdateOfferDetails = this.activity === '600103';
      const usedAttachmentTypes = this.cmpHirType === '9' && isUpdateOfferDetails ? this.getUsedAttachmentTypes() : [];
      fileArray.forEach((file) => {
        const fileObj = { category: {}, file: File };
        const fileName = file.name.split('.')[0];
        const filterFile = this.attachmnetTypeData.filter((elem) => {
          if (this.cmpHirType === '9' && isUpdateOfferDetails && usedAttachmentTypes.includes(elem.attachmentType)) {
            return false;
          }
          const atchType = elem.attachmentType.toLowerCase();
          const fileName_ = fileName.toLowerCase();
          const atchType_ = atchType.split(' ');
          if (atchType === fileName_) {
            return elem;
          } else if (atchType_[0] === fileName_) {
            return elem;
          }
        });
        fileObj.category = filterFile.length > 0 ? filterFile[0] : '';
        fileObj.file = file;
        dupFileObjArray.push(fileObj);
      });
    }
    return dupFileObjArray;
  }

  manualMapping(mappedFile) {
    const allEditFileNames = [];
    const allNewFileNames = [];
    let allFileNames = [];
    this.editFileNameArray.forEach((elem) => {
      const fileName = elem.fileName.substring(elem.fileName.indexOf('-') + 1, elem.fileName.length);
      allEditFileNames.push(fileName);
    });
    this.fileNameArray.forEach((fileName_) => {
      const fileName = fileName_.substring(fileName_.indexOf('-') + 1, fileName_.length);
      allNewFileNames.push(fileName);
    });
    allFileNames = allEditFileNames.concat(allNewFileNames);
    console.log(allFileNames);
    let availableAttachmentTypes = this.attachmnetTypeData;
    const isUpdateOfferDetails = this.activity === '600103';
    if (this.cmpHirType === '9' && isUpdateOfferDetails) {
      const usedAttachmentTypes = this.getUsedAttachmentTypes();
      availableAttachmentTypes = this.attachmnetTypeData.filter(
        (attachType) => !usedAttachmentTypes.includes(attachType.attachmentType),
      );
    }

    const dialogRef = this.dialog.open(MultipleFileDialogComponent, {
      width: '700px',
      height: '300px',
      data: {
        attachmentList: this.filesList,
        ModuleData: this.SendfileInput,
        allowedfileType: this.allowedTypes,
        uploadType: this.uploadType,
        previousFiles: allFileNames,
        existingFiles: this.filename,
        attachmentTypes: availableAttachmentTypes,
        mappedFiles: mappedFile,
      },
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        const dupFileArray = await this.renamingFiles(result);
        dupFileArray.forEach((element) => {
          // this.fileNameArray_.push(element.file.name);
          const fileName_ = element.file.name;
          if (this.fileNameArray.indexOf(fileName_) == -1) {
            this.fileNameArray.push(fileName_);
            this.allFilesList.push(element);
          }
        });

        const hasConfirmationEmail = this.allFilesList.some((file) => file.attachmentId == 288);
        const hasOfferValidityExpiredApproval = this.allFilesList.some((file) => file.attachmentId == 289);

        if (this.offerRejectCheck && !hasConfirmationEmail) {
          const data = {
            msg: 'Please attach only Candidate Confirmation Email.',
            isSuccess: false,
          };
          this.activityService.openSnackBar(data, 'danger-snack');
        } else if (this.offerInvalidRejectCheck && !hasConfirmationEmail && !hasOfferValidityExpiredApproval) {
          const data = {
            msg: 'Please attach only Candidate Confirmation Email and Offer validity expired exceptional approval.',
            isSuccess: false,
          };
          this.activityService.openSnackBar(data, 'danger-snack');
        }

        const fileMerge = this.allFilesList;
        const deletedFile = this.deletedFile;
        this.fileOutput.emit({ fileMerge, deletedFile, fileMerge1: fileMerge, deletedFile1: deletedFile });
      }
    });
  }

  renamingFiles(fileArr) {
    const dupFileArray = [];
    if (fileArr) {
      fileArr.forEach((elem) => {
        const fileObj = { file: {}, attachmentId: 0 };
        if (elem && elem.category && elem.category.attachmentType && elem.file && elem.file.name) {
          const renFile = elem.category.attachmentType + '-' + elem.file.name;
          const dupFile = this.createDupFile(elem.file, renFile);
          fileObj.file = dupFile;
          fileObj.attachmentId = elem.category.attachmentId;
          dupFileArray.push(fileObj);
        }
      });
    }
    return dupFileArray;
  }

  createDupFile = (file, name) => {
    return new File([file], name);
  };

  private getUsedAttachmentTypes(): string[] {
    const usedTypes: string[] = [];

    this.editFileNameArray.forEach((fileItem) => {
      if (fileItem.fileName && fileItem.fileName.includes('-')) {
        const attachmentType = fileItem.fileName.substring(0, fileItem.fileName.indexOf('-'));
        if (attachmentType && !usedTypes.includes(attachmentType)) {
          usedTypes.push(attachmentType);
        }
      }
    });

    // Extract attachment types from currently selected new files (allFilesList)
    this.allFilesList.forEach((fileItem) => {
      const fileName = fileItem.attachmentId ? fileItem.file.name : fileItem.name;
      if (fileName && fileName.includes('-')) {
        const attachmentType = fileName.substring(0, fileName.indexOf('-'));
        if (attachmentType && !usedTypes.includes(attachmentType)) {
          usedTypes.push(attachmentType);
        }
      }
    });

    // Extract attachment types from fileNameArray (already processed files)
    this.fileNameArray.forEach((fileName) => {
      if (fileName && fileName.includes('-')) {
        const attachmentType = fileName.substring(0, fileName.indexOf('-'));
        if (attachmentType && !usedTypes.includes(attachmentType)) {
          usedTypes.push(attachmentType);
        }
      }
    });

    return usedTypes;
  }
}
